import { GetString } from 'fluent-react';
import React from 'react';
import styled from 'styled-components';
import { demiFontWeight } from '../../cssVariables';
import { googleAnalyticsEvent } from '../../useGoogleAnalytics';
import {
  LefFooterContainer,
  StartButtonContainer,
} from '../landing/Grid';
import { primaryColor1 } from '../Utils';
import Icon from './Icon';

//#region Styling
const Root = styled.div`
  max-width: 420px;
  margin: auto;
`;

const NavIconsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
`;

const ScrollPromptContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;
const Button = styled.a`
  color: white;
  background-color: ${primaryColor1};
  font-size: 1.375rem;
  border-radius: 0.625rem;
  padding: 0.35rem 2.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: ${demiFontWeight};
  cursor: pointer;
  margin: 1.25rem 0 2rem;

  &:hover {
    color: ${primaryColor1};
    background-color: white;
  }
`;

const JumpToSectionTitle = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: ${primaryColor1};
  font-size: 0.875rem;
  text-transform: uppercase;
  margin-bottom: 1.25rem;

  &::before,
  &::after {
    content: '';
    display: block;
    flex-grow: 1;
    height: 0;
    border-top: solid 1px ${primaryColor1};
  }
`;

const Title = styled.div`
  padding: 0 0.5rem;
`;

//#endregion

interface IconInfo {
  slideIndex: number;
  label: string;
  svgFileName: string;
}

const getIconInfo = (getFluentString: GetString): IconInfo[] => ([
  {
    slideIndex: 1,
    label: getFluentString('section-nav-section-economic-structure'),
    svgFileName: 'nav-icon-1.svg',
  },
  {
    slideIndex: 3,
    label: getFluentString('section-nav-section-market-dynamics'),
    svgFileName: 'nav-icon-2.svg',
  },
  {
    slideIndex: 6,
    label: getFluentString('section-nav-section-strategy-space'),
    svgFileName: 'nav-icon-3.svg',
  },
  {
    slideIndex: 9,
    label: getFluentString('section-nav-section-diversification-path'),
    svgFileName: 'nav-icon-4.svg',
  },
]);

interface Props {
  onIconClick: (slideIndex: number) => void;
  getFluentString: GetString;
}

const LandingBottomNav = (props: Props) => {
  const {getFluentString, onIconClick} = props;
  const iconInfo = getIconInfo(getFluentString);
  const icons = iconInfo.map(({slideIndex, label, svgFileName}) => {
    const onClick = () => {
      onIconClick(slideIndex);
      googleAnalyticsEvent('Country Profiles Landing Bottom Nav Button', `click -- to ${label}`);
    };
    return (
      <Icon
        onClick={onClick}
        svgFileName={svgFileName}
        label={label}
        key={`landing-to-slide-${slideIndex}`}
      />
    );
  });
  return (
    <>
      <StartButtonContainer>
        <ScrollPromptContainer>
          <Button
            onClick={() => onIconClick(1)}
          >
            {getFluentString('landing-bottom-nav-scroll-prompt')}
          </Button>
        </ScrollPromptContainer>
      </StartButtonContainer>
      <LefFooterContainer>
        <Root>
          <JumpToSectionTitle>
            <Title>
              {getFluentString('landing-bottom-nav-jump-to-specific-section')}
            </Title>
          </JumpToSectionTitle>
          <NavIconsContainer>
            {icons}
          </NavIconsContainer>
        </Root>
      </LefFooterContainer>
    </>
  );
};

export default LandingBottomNav;
